<template>
  <div class="wizard-container">
    <div class="header">
      <el-steps v-show="wizardEngine.showOverview" :active="wizardEngine.currentStepIndex" align-center>
        <el-step
          v-for="(step, idx) in wizardEngine.steps"
          :key="idx"
          :title="$t(step.title)"
          :description="step.description"
        ></el-step>
      </el-steps>
    </div>
    <crud-editor
      ref="editor"
      :key="wizardEngine.currentStepIndex"
      v-model="wizardEngine.updateForm"
      :definition="wizardEngine.currentDefinition"
      v-bind="wizardEngine.currentProps"
      :form-label-width="wizardEngine.currentLabelWidth"
      @form="handleForm"
      @action="handleAction"
    >
      <template>
        <base-button
          v-for="(action, idx) in wizardEngine.currentActions"
          :key="idx"
          :loading="wizardEngine.loading"
          :type="action.type || 'primary'"
          :caption="$t(action.label)"
          :icon-only="false"
          @click="handleAction"
        />
      </template>
    </crud-editor>
  </div>
</template>

<script>
import BaseButton from '@/components/crud/BaseButton';
import WizardEngine from '../helpers/WizardEngine';
import CrudEditor from '@/components/crud/Editor';

export default {
  components: {
    CrudEditor,
    BaseButton
  },
  props: {
    definition: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      wizardEngine: null,
      done: false
    };
  },
  watch: {
    wizardEngine: {
      deep: true,
      handler: function(wizardEngine) {
        this.done = wizardEngine.isDone;
      }
    },
    done(done) {
      if (done) {
        this.$emit('done', this.wizardEngine.form);
      }
    }
  },
  created() {
    this.wizardEngine = new WizardEngine(this.definition);
  },
  methods: {
    handleRouteLeave(to, from, next) {
      next();
    },
    handleForm(form) {
      this.wizardEngine.updateForm(form);
    },
    async handleAction(name, params = {}) {
      switch (name) {
        case 'next':
        case 'done': {
          const persist = await this.$refs.editor.persistForm();
          if (persist) {
            this.wizardEngine.action(name, params);
          }
          break;
        }
        default:
          this.wizardEngine.action(name, params);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.wizard-container {
  .header {
    margin-bottom: 1em;
  }
}
</style>
